import Vue from 'vue';
import Router from 'vue-router';

import AccessDenied from '../components/auth0/AccessDenied';
import AmazonLogin from '../views/AmazonLogin';
import CommercePreview from '../views/CommercePreview';
import LoginRedirect from '../components/auth0/LoginRedirect';
import TestCreative from '../views/Creative/Test';
import PageNotFound from '../components/auth0/PageNotFound';

import IPTEST from '../views/IPTEST';

Vue.use(Router);

const PUBLIC_ROUTE = { isPublic: true };
const PRIVATE_ROUTE = { isPublic: false };
const SELF_SERVE_ROUTE = { isPublic: false, selfServe: true };
const COMMERCE_EDITOR_ONLY = { isPublic: false, commerceEditorOnly: true };
const MEDIA_MANAGER_ONLY = { isPublic: false, mediaManagerOnly: true };

export default new Router({
  mode: 'history',
  routes: [
    {
      name: 'home',
      path: '/',
      meta: SELF_SERVE_ROUTE,
      redirect: '/dashboard',
    },
    {
      name: 'insights',
      path: '/dashboard',
      meta: SELF_SERVE_ROUTE,
    },
    {
      name: 'insights-base',
      path: '/dashboard/*',
      meta: SELF_SERVE_ROUTE,
    },
    {
      name: 'commerce-home',
      path: '/commerce',
      meta: COMMERCE_EDITOR_ONLY,
      redirect: '/commerce/creative',
    },
    {
      name: 'creative',
      path: '/commerce/creative',
      component: () => import('../views/Creative/Creative'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'creative-connect',
      path: '/commerce/creative/connect',
      component: () => import('../views/Connect/Connect'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'media-manager',
      path: '/media-manager',
      meta: MEDIA_MANAGER_ONLY,
      redirect: '/media-manager/bulk',
    },
    {
      name: 'media-manager-master-list-management',
      path: '/media-manager/manage-values',
      component: () => import('../views/MediaManager/ListManagement'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'media-manager-bulk',
      path: '/media-manager/bulk',
      component: () => import('../views/MediaManager/MediaManager'),
      redirect: '/media-manager/bulk/creative',
      meta: MEDIA_MANAGER_ONLY,
      children: [
        {
          name: 'media-manager-bulk-creative',
          path: 'creative',
          component: () => import('../views/MediaManager/BulkLinks'),
          meta: MEDIA_MANAGER_ONLY,
        },
        {
          name: 'media-manager-bulk-discover',
          path: 'discover',
          component: () => import('../views/MediaManager/BulkLinks'),
          meta: MEDIA_MANAGER_ONLY,
        },
      ],
    },
    {
      name: 'media-manager-generated-links',
      path: '/media-manager/generated-links',
      component: () => import('../views/MediaManager/MediaPlan'),
      meta: MEDIA_MANAGER_ONLY,
    },
    {
      name: 'discover',
      path: '/commerce/discover',
      component: () => import('../views/Discover/Discover'),
      redirect: '/commerce/discover/products',
      meta: COMMERCE_EDITOR_ONLY,
      children: [
        {
          name: 'products',
          path: 'products',
          component: () => import('../views/Discover/Products'),
          meta: COMMERCE_EDITOR_ONLY,
        },
        {
          name: 'products-edit',
          path: 'products/:id/edit',
          component: () => import('../views/Discover/Products'),
          meta: COMMERCE_EDITOR_ONLY,
        },
        {
          name: 'views',
          path: 'views',
          component: () => import('../views/Discover/Views'),
          meta: COMMERCE_EDITOR_ONLY,
        },
        {
          name: 'views-edit',
          path: 'views/:id/edit',
          component: () => import('../views/Discover/Views'),
          meta: COMMERCE_EDITOR_ONLY,
        },
        {
          name: 'archived',
          path: 'archived',
          component: () => import('../views/Discover/Archived'),
          meta: COMMERCE_EDITOR_ONLY,
        },
      ],
    },
    {
      name: 'discover-preview',
      path: '/commerce/discover-preview*',
      component: () => import('../views/Discover/BrandSitePreview'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'discover-connect',
      path: '/commerce/discover/connect',
      component: () => import('../views/Connect/Connect'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'amazon-sales-insights-signup',
      path: '/amazon-sales-insights-signup',
      component: AmazonLogin,
      meta: SELF_SERVE_ROUTE,
    },
    {
      name: 'amazon-signup-confirmation',
      path: '/amazon-sales-insights-signup/signup-confirmation',
      component: AmazonLogin,
      component: () => import('../views/AmazonLoginConfirm'), // eslint-disable-line no-dupe-keys
      meta: SELF_SERVE_ROUTE,
    },
    {
      name: 'attach-studio-preview',
      path: '/attach-studio/preview/:playerId',
      component: CommercePreview,
      meta: PUBLIC_ROUTE,
    },
    {
      name: 'attach-studio-test-creative',
      path: '/test-creative',
      component: TestCreative,
      meta: PUBLIC_ROUTE,
    },
    {
      name: 'attach-studio-product-detail',
      path: '/attach-studio/product/:productId',
      component: () => import('../views/Creative/ProductDetail'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'attach-studio-build',
      path: '/attach-studio/build/:playerId',
      component: () => import('../views/Creative/Build'),
      meta: PRIVATE_ROUTE,
    },
    {
      name: 'brands',
      path: '/brands',
      component: () => import('../views/BrandList'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'carts',
      path: '/carts',
      component: () => import('../views/RetailerCarts'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'data-management',
      path: '/data-management',
      component: () => import('../views/DataManagement'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'users',
      path: '/users',
      component: () => import('../views/UserRoles'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'inventoryReport',
      path: '/inventoryReport',
      component: () => import('../views/InventoryReport'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'create-brand',
      path: '/create-brand/',
      component: () => import('../views/BrandForm'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'edit-brand',
      path: '/edit-brand/:brandId',
      component: () => import('../views/BrandForm'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'set-brand',
      path: '/set-brand/:brandId',
      component: () => import('../views/SetBrand'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'create-cart',
      path: '/create-cart',
      component: () => import('../views/CartForm'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'edit-cart',
      path: '/edit-cart/:cartId',
      component: () => import('../views/CartForm'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'login',
      path: '/login',
      redirect: '/login-redirect',
      meta: PUBLIC_ROUTE,
    },
    {
      name: 'ip-test',
      path: '/ip-test',
      component: IPTEST,
      meta: PUBLIC_ROUTE,
    },
    {
      path: '/__/auth/handler',
      redirect: '/',
    },
    {
      name: 'partners',
      path: '/partners',
      component: () => import('../views/RetailPartners'),
      meta: PRIVATE_ROUTE,
    },
    {
      // this view is a temporary way to add new portfolio entries to firebase
      name: 'addPortfolio',
      path: '/add-portfolio',
      component: () => import('../views/AddPortfolio'),
      meta: COMMERCE_EDITOR_ONLY,
    },
    {
      name: 'login-redirect',
      path: '/login-redirect',
      component: LoginRedirect,
      meta: PUBLIC_ROUTE,
    },
    {
      name: 'access-denied',
      path: '/access-denied',
      component: AccessDenied,
      meta: PUBLIC_ROUTE,
    },
    {
      name: 'callback',
      path: '/callback',
      component: () => import('../components/auth0/LoginCallback'),
      meta: PRIVATE_ROUTE,
    },
    {
      name: '404',
      path: '/404',
      component: PageNotFound,
      meta: PRIVATE_ROUTE,
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
});
